import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthenticationService } from '@src/app/services/authentication.service';

export const AuthGuard : CanActivateFn = () => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    router.navigate(['main']);
    return false;
  }

  return true;
};
